import { styled } from "@vitality-ds/system";
import baseBreadcrumbsContainerStyles from "./styles/BaseBreadcrumbsContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseBreadcrumbsContainer = styled("ol", baseBreadcrumbsContainerStyles);